import { useProducts } from 'contexts/products-context';
import { useI18n } from 'contexts/i18n-context';
import { IProduct } from 'models';

import * as S from './style';

interface ICategoryOption {
  id: string;
  label: string;
}

const getCategoryId = (product: IProduct) =>
  String(product.categoryId ?? product.categoryName ?? '');

const getCategoryLabel = (product: IProduct, locale: 'en' | 'zh') => {
  if (locale === 'en') {
    return product.categoryNameEn || product.categoryName || product.categoryNameZh || '';
  }

  return product.categoryNameZh || product.categoryName || product.categoryNameEn || '';
};

const Filter = () => {
  const { allProducts, filters, filterProducts, products } = useProducts();
  const { locale, t } = useI18n();
  const sourceProducts = allProducts.length ? allProducts : products;
  const categories = sourceProducts.reduce<ICategoryOption[]>((result, product) => {
    const id = getCategoryId(product);

    if (!id || result.some((category) => category.id === id)) {
      return result;
    }

    result.push({
      id,
      label: getCategoryLabel(product, locale),
    });

    return result;
  }, []);
  const activeCategoryId = filters[0] || '';

  const toggleCheckbox = (categoryId: string) => {
    const nextFilters = activeCategoryId === categoryId ? [] : [categoryId];

    filterProducts(nextFilters);
  };

  const createCheckbox = (category: ICategoryOption) => (
    <S.Checkbox
      checked={activeCategoryId === category.id}
      handleOnChange={toggleCheckbox}
      key={category.id}
      label={category.label}
      value={category.id}
    />
  );

  const createCheckboxes = () => categories.map(createCheckbox);

  return (
    <S.Container>
      <S.Title>{t('filter.categories')}</S.Title>
      <S.Options>{createCheckboxes()}</S.Options>
    </S.Container>
  );
};

export default Filter;
